var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CartModel from '../../models/Cart';
const ELEMENT = '#__cart';
const ELEMENT_CART = '[name="__save-in-cart"]';
const ELEMENT_STASH = '[name="__save-in-stash"]';
const KEY = 'carts';
export class Cart {
    constructor() {
        this.element = null;
        window.addEventListener('load', (event) => {
            this.element = document.querySelector(ELEMENT);
            this.load();
        });
    }
    update() {
        if (!this.element)
            return;
        let orders = JSON.parse(localStorage.getItem(KEY) || '[{ id: "" }]') || [{ id: '' }];
        this.element.querySelectorAll('.badge').forEach(element => {
            if (orders.length) {
                element.style.display = '';
            }
            else {
                element.style.display = 'none';
            }
            element.textContent = String(orders.length);
        });
        // document.querySelectorAll<HTMLElement>('.mypage.cart').forEach(element => {
        //     if (orders.length) {
        //         element.style.display = '';
        //     } else {
        //         element.style.display = 'none';
        //     }
        // })
        let current = orders.some(order => {
            const url = new URL(location.href);
            return order.id == url.searchParams.get("orders[0][id]");
        });
        if (current) {
            document.querySelectorAll(ELEMENT_CART).forEach(element => {
                element.style.display = 'none';
            });
            document.querySelectorAll(ELEMENT_STASH).forEach(element => {
                element.style.display = '';
            });
        }
        else {
            document.querySelectorAll(ELEMENT_CART).forEach(element => {
                element.style.display = '';
            });
            document.querySelectorAll(ELEMENT_STASH).forEach(element => {
                element.style.display = 'none';
            });
        }
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            let orders = JSON.stringify(yield CartModel.find());
            localStorage.setItem(KEY, orders);
            this.update();
        });
    }
    ;
    save(order) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CartModel.save(order).then(response => {
                if (response[0].id) {
                    const url = new URL(location.href);
                    url.searchParams.set("orders[0][id]", response[0].id);
                    history.pushState(null, '', url);
                }
                this.load();
                return response[0];
            });
        });
    }
    ;
    saveMulti(order) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CartModel.save(order).then(response => {
                this.load();
                return response[0];
            });
        });
    }
    ;
    validate(cartId, ev) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CartModel.validate(cartId).then(response => {
                return response;
            });
        });
    }
    ;
}
const cart = new Cart();
export default cart;
window.addEventListener('storage', (event) => {
    cart.update();
});
